import React, { useContext, useState } from "react";
import { TableHead } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Context from "../../../context/Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";


export const SimilarParts = ({
    similarParts
}) => {

    const {
        loading,
        setLoading
    } = useContext(Context);

    var style = {
        padding: 0.6,
        textAlign: "center",
        whiteSpace: "nowrap",
    };

    return (
        <>
            {loading ? (
                <center>
                    <div className="loading-container">
                        <FontAwesomeIcon icon={faSpinner} spin />
                    </div>
                </center>
            ) : (
                <TableContainer
                    component={Paper}
                    sx={{ overflow: "auto" }}
                >
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={style}> PEDIDO </TableCell>
                                <TableCell sx={style}> POSIÇÃO </TableCell>
                                <TableCell sx={style}> ORDEM </TableCell>
                                <TableCell sx={style}> ZFER </TableCell>
                                <TableCell sx={style}> SETOR </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {similarParts ? similarParts.map((item) => (
                                <TableRow>
                                    <TableCell sx={style}> {item.pedido_Codigo} </TableCell>
                                    <TableCell sx={style}> {item.pedido_Posicao} </TableCell>
                                    <TableCell sx={style}> {item.ordem_Serial} </TableCell>
                                    <TableCell sx={style}> {item.ordem_CodMaterial} </TableCell>
                                    <TableCell sx={style}> {item.setor_Concatenado} </TableCell>
                                </TableRow>
                            )) : "NÃO FORAM ECONTRADAS PEÇAS SEMELHANTES"}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
}


